export default "__VITE_ASSET__DTBiQ0XQ__"